export const Bars = ( {data, x, y, color, innerHeight}) => (
  data.map((d, i) => {
    // if it doesn't get called, the coloring is absolutely weird
    // previously it was called due to console.log, and after removing it,
    // the bug started to appear!
    // const barColor = color(d.fatty_acid);  
    return (
        <rect 
          className="inactive"
          key={i}
          x={x(d.label)}
          y={y(d.probability)} 
          width={x.bandwidth()}
          height={innerHeight - y(d.probability)}
          fill={'lightgray'}
        />
      )
  }
  )
);
